<template>
  <div class="line contPadding">
    <div class="main-title">用户管理</div>
    <el-row class="content-container">
      <el-col :span="7">
        <div class="selectList">
          <div class="title"><span></span>组织机构树：</div>
          <div class="custom-tree-container">
            <el-tree
              :props="props"
              :load="rootloadNode"
              lazy
              :render-content="renderContent"
              :expand-on-click-node="false"
            ></el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="17">
        <el-button
          type="primary"
          class="changeBtn"
          @click="addUser"
          v-show="addShow"
          >添加</el-button
        >
        <div v-show="tableShow">
          <el-table :data="userList" style="width: 100%">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column
              prop="loginAccount"
              label="登录账户"
            ></el-table-column>
            <el-table-column prop="orgName" label="所属机构"></el-table-column>
            <el-table-column
              prop="userRealname"
              label="用户姓名"
            ></el-table-column>
            <el-table-column prop="userGendercode" label="性别">
              <template slot-scope="scope">
                <span>{{
                  scope.row.userGendercode === '0'
                    ? '女'
                    : scope.row.userGendercode === '1'
                    ? '男'
                    : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="userIdCard"
              label="身份证号"
            ></el-table-column>
            <el-table-column prop="userMail" label="邮箱"></el-table-column>
            <el-table-column prop="accountStatus" label="账户状态">
              <template slot-scope="scope">
                <span>{{
                  scope.row.accountStatus === '0'
                    ? '正常'
                    : scope.row.accountStatus === '1'
                    ? '冻结'
                    : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="!rootNodeFlag" width="150px">
              <template slot-scope="scope" fixed="right">
                <el-button
                  type="text"
                  style="font-size: 12px"
                  @click="handleEdit(scope.row)"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  style="font-size: 12px"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  style="font-size: 12px"
                  @click="reset(scope.row)"
                  >修改密码</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="850px"
      @opened="resetForm"
    >
      <div class="submitForm">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="账号" prop="loginAccount">
                <el-input
                  v-model.trim="ruleForm.loginAccount"
                  :disabled="Accountdisabled"
                  @blur="blur"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" class="el-style">
              <el-form-item label="用户部门">
                <el-input
                  v-model="ruleForm.code"
                  :disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="账户状态">
                <el-select v-model="ruleForm.accountStatus">
                  <el-option label="正常" value="0" />
                  <el-option label="冻结" value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="姓名">
                <el-input v-model="ruleForm.userRealname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-show="loginPwdShow">
              <el-form-item label="密码" prop="loginPwd">
                <el-input
                  type="password"
                  v-model.trim="ruleForm.loginPwd"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="手机">
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="邮箱地址">
                <el-input v-model="ruleForm.userMail"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="身份证号">
                <el-input v-model="ruleForm.userIdCard"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="性别">
                <el-select v-model="ruleForm.userGendercode">
                  <el-option label="男" value="1" />
                  <el-option label="女" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" class="el-style">
              <el-form-item label="监管类型">
                <el-select v-model="ruleForm.superviseType">
                  <el-option label="生产企业" value="1" />
                  <el-option label="经营企业" value="0" />
                  <el-option label="零售药店" value="2" />
                  <el-option label="医疗机构" value="3" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" class="el-style">
              <el-form-item label="监察区域">
                <el-input
                  v-model="ruleForm.superviseAreaName"
                  readonly
                  @click.native="inputTree_JG"
                />
                <div class="backTree" v-show="treeShow_JG">
                  <div class="tree">
                    <div class="title"><span></span>监察区域</div>
                    <el-button
                      type="primary"
                      class="sureBtn"
                      @click="sureClick_JG"
                      >确定</el-button
                    >
                    <el-button class="closeBtn" @click="closeClick"
                      >取消</el-button
                    >
                    <el-tree
                      ref="tree_JG"
                      :props="propsJG"
                      :load="loadNodeJG"
                      lazy
                      show-checkbox
                    />
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="20" class="el-style">
              <el-form-item label="角色" prop="roleIds">
                <input
                  class="el-input__inner"
                  v-model="keyword"
                  @keyup="searchRole"
                  placeholder="检索关键字"
                />
              </el-form-item>
              <div style="margin-left: 100px">
                <div class="checkbox-container">
                  <el-checkbox-group v-model="ruleForm.roleIds">
                    <div v-for="item in roleIdsData" :key="item.roleId">
                      <el-checkbox :label="item.roleId">{{
                        item.roleName
                      }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <!-- <p class="el-form-item__error" v-show="ruleForm.roleIds.length === 0">请选择角色</p> -->
                <div class="checkbox-operate">
                  <el-checkbox
                    v-model="allRroleChecked"
                    @change="checkAllChange"
                    >{{ allRroleCheckedText }}</el-checkbox
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="重置密码" :visible.sync="pwdResetVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="新密码">
          <el-input
            type="password"
            placeholder="请输入新密码"
            v-model.trim="newPwd"
          />
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input
            type="password"
            placeholder="确认密码"
            v-model.trim="confirmPwd"
          />
        </el-form-item>
        <p class="err-tips">{{ errMsg }}</p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetPwdSubmit()">确 定</el-button>
        <el-button @click="pwdResetVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
let obj;
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogTitle: '新增用户',
      allRroleChecked: false,
      keyword: '',
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      propsJG: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      parentId: '',
      data: [],
      userList: [],
      tableShow: false,
      submitShow: false,
      Accountdisabled: false,
      ruleForm: {
        code: '',
        loginAccount: '',
        userRealname: '',
        loginPwd: '',
        phone: '',
        userMail: '',
        accountStatus: '0',
        userIdCard: '',
        userGendercode: '',
        roleIds: [],
        superviseAreaCode: [],
        superviseAreaName: '',
        superviseType: [],
        orgId: ''
      },
      rules: {
        loginAccount: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        loginPwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        roleIds: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      roleIdsData: [],
      allAoleIdsData: [],
      unitName: '',
      disabled: true,
      addShow: false,
      loginPwdShow: true,
      treeShow_JG: false,
      method: '',
      orgId: '',
      dialogVisible: false,
      pwdResetVisible: false,
      newPwd: '',
      confirmPwd: '',
      userId: '',
      errMsg: '',
      rootNodeFlag: true
    };
  },
  computed: {
    allRroleCheckedText() {
      return this.allRroleChecked ? '反选' : '全选';
    }
  },
  methods: {
    blur() {
      this.$request({
        url: 'rest/bsp/pubUser/queryUserByName',
        data: {
          loginAccount: this.ruleForm.loginAccount
        }
      }).then(res => {
        if (res.data > 0) {
          this.$message.error('此用户名太受欢迎,请更换一个');
          this.ruleForm.loginAccount = '';
        }
      });
    },
    inputTree_JG() {
      this.treeShow_JG = true;
    },
    handleSizeChange(val) {
      this.userList = [];
      this.currentPage = 1;
      this.pageSize = val;
      this.tableinfo();
      this.userList = [];
    },
    handleCurrentChange(val) {
      this.userList = [];
      this.currentPage = val;
      this.tableinfo();
      this.userList = [];
    },
    // 监管区划提交确认按钮
    sureClick_JG() {
      this.treeShow_JG = false;
      const resJG = this.$refs.tree_JG.getCheckedNodes();
      const arrJGcode = [];
      const arrJGname = [];
      resJG.forEach(item => {
        arrJGcode.push(item.code);
        arrJGname.push(item.name);
      });
      this.ruleForm.superviseAreaName =
        arrJGname.length > 0 ? arrJGname.join(',') : '';
      this.ruleForm.superviseAreaCode = arrJGcode || []; // 监管区划code
    },
    // 关闭
    closeClick() {
      this.treeShow_JG = false;
    },
    // 监管区划
    loadNodeJG(node, resolve) {
      if (node.level === 0) {
        this.ID1 = 'CN';
        return resolve([{ name: '中华人民共和国' }]);
      }
      if (node.level > 1) {
        this.ID1 = node.data.code;
      }
      this.$request({
        url: 'rest/bsp/pubCant/loadRegionByPid',
        data: {
          parentId: this.ID1
        }
      }).then(res => {
        resolve(res);
      });
    },
    // 查询所有角色
    loadRoleList() {
      this.$request({
        url: 'rest/bsp/pubUser/loadRoleList',
        data: {
          parentId: this.parentId
        }
      }).then(res => {
        this.allAoleIdsData = res;
        this.roleIdsData = res;
      });
    },
    // 组织机构树
    rootloadNode(node, resolve) {
      if (node.level === 0) {
        this.parentId = 'root';
        return resolve([{ name: '组织机构树' }]);
      }
      if (node.level > 1) {
        this.parentId = node.data.code;
      }
      this.$request({
        url: 'rest/bsp/pubOrganInfo/loadOrgByPid',
        data: {
          parentId: this.parentId
        }
      }).then(res => {
        this.data = res;
        resolve(res);
      });
    },
    tableinfo() {
      this.$request({
        url: 'rest/bsp/pubUser/loadUserByClause',
        data: {
          orgId: this.orgId,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.total = res.total;
        this.userList = [];
        res.list.forEach(item => {
          const tableItem = {
            accountStatus: item.accountStatus, // 账户状态（0 正常 1冻结）
            loginAccount: item.loginAccount, // 登录账户
            orgName: item.orgName, // 所属机构
            orgId: item.orgId, // 组织机构id
            userGendercode: item.userGendercode, // 性别代码（0女 1男）
            userIdCard: item.userIdCard, // 身份证号
            id: item.id,
            userMail: item.userMail, // 邮箱
            userRealname: item.userRealname // 用户姓名
          };
          this.userList.push(tableItem);
        });
      });
    },
    // 点击树每条信息展示
    showUserList(data) {
      this.userList = [];
      this.unitName = data.name;
      this.ruleForm.orgId = data.code;
      this.orgId = data.code;
      this.tableShow = true;
      if (data.name === '组织机构树') {
        this.rootNodeFlag = true;
        this.addShow = false;
      } else {
        this.rootNodeFlag = false;
        this.addShow = true;
      }
      this.tableinfo();
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span on-click={() => this.showUserList(data)}>{node.label}</span>
        </span>
      );
    },
    empty() {
      this.ruleForm.loginPwd = '';
      this.ruleForm.phone = '';
      this.ruleForm.userMail = '';
      this.ruleForm.accountStatus = '0';
      this.ruleForm.userIdCard = '';
      this.ruleForm.userGendercode = '';
      this.ruleForm.roleIds = [];
      this.ruleForm.superviseType = '';
      this.ruleForm.superviseAreaCode = [];
      this.ruleForm.superviseAreaName = '';
      this.ruleForm.loginAccount = '';
      this.ruleForm.userRealname = '';
    },
    // 详情
    loadUserById(row) {
      this.$request({
        url: 'rest/bsp/pubUser/loadUserById',
        data: {
          id: row.id
        }
      }).then(res => {
        this.ruleForm.accountStatus = res.accountStatus; // 账户状态
        this.ruleForm.userGendercode = res.userGendercode; // 性别
        this.ruleForm.code = this.unitName;
        this.ruleForm.loginAccount = res.loginAccount; // 登录账户
        this.ruleForm.userRealname = res.userRealname; // 用户姓名
        this.ruleForm.loginPwd = res.loginPwd; // 登录密码
        this.ruleForm.phone = res.phone; // 电话
        this.ruleForm.userMail = res.userMail; // 邮箱
        this.ruleForm.userIdCard = res.userIdCard; // 身份证号
        this.ruleForm.id = res.id; // 新增不传，修改传
        // this.ruleForm.roleIds = res.pubUserRoles //角色// chooseState 是否选中  0未选中 1已选中
        for (const item of res.pubUserRoles) {
          if (item.chooseState === '1') {
            this.ruleForm.roleIds.push(item.roleId);
          }
        }
        this.ruleForm.superviseAreaCode =
          res.superviseAreaCode.indexOf(',') > -1
            ? res.superviseAreaCode.split(',')
            : [res.superviseAreaCode]; // 监管区域
        this.ruleForm.superviseAreaName = res.superviseAreaName;
      });
    },
    // 修改
    handleEdit(row) {
      this.empty();
      this.method = 'update';
      this.ruleForm.loginPwd = '';
      this.Accountdisabled = true;
      this.loadRoleList(); // 查询所有角色
      this.submitShow = true;
      this.ruleForm.code = this.unitName;
      this.loginPwdShow = false;
      this.loadUserById(row); // form详情
      this.dialogTitle = '编辑用户';
      this.allRroleChecked = false;
      this.dialogVisible = true;
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    // 新增
    addUser() {
      this.empty();
      this.ruleForm.accountStatus = '0';
      this.ruleForm.userGendercode = '';
      this.loginPwdShow = true;
      this.Accountdisabled = false;
      this.method = 'add';
      this.loadRoleList(); // 查询所有角色
      this.submitShow = true;
      this.ruleForm.code = this.unitName;
      this.dialogTitle = '新增用户';
      this.allRroleChecked = false;
      this.dialogVisible = true;
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    // 确认提交按钮
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.method === 'add') {
            obj = {
              method: this.method,
              accountStatus: this.ruleForm.accountStatus, // 账户状态(0 正常 1冻结）
              loginAccount: this.ruleForm.loginAccount, // 登录账户
              loginPwd: this.$util.pwdMd5(this.ruleForm.loginPwd), // 密码
              orgId: this.ruleForm.orgId, // 组织机构id
              phone: this.ruleForm.phone,
              roleIds: this.ruleForm.roleIds.join(','), // 角色ids
              superviseAreaCode: this.ruleForm.superviseAreaCode.join(','), // 监察区域
              superviseAreaName: this.ruleForm.superviseAreaName, // 监察区域
              superviseType: this.ruleForm.superviseType, // 监察类型
              userGendercode: this.ruleForm.userGendercode, // 性别代码（0女 1男）
              userIdCard: this.ruleForm.userIdCard, // 身份证号
              userMail: this.ruleForm.userMail, // 邮箱
              userRealname: this.ruleForm.userRealname // 用户姓名
            };
          } else {
            obj = {
              method: this.method,
              accountStatus: this.ruleForm.accountStatus, // 账户状态(0 正常 1冻结）
              loginAccount: this.ruleForm.loginAccount, // 登录账户
              orgId: this.ruleForm.orgId, // 组织机构id
              id: this.ruleForm.id,
              phone: this.ruleForm.phone,
              roleIds: this.ruleForm.roleIds.join(','), // 角色ids
              superviseAreaCode: this.ruleForm.superviseAreaCode.join(','), // 监察区域
              superviseAreaName: this.ruleForm.superviseAreaName,
              superviseType: this.ruleForm.superviseType, // 监察类型
              userGendercode: this.ruleForm.userGendercode, // 性别代码（0女 1男）
              userIdCard: this.ruleForm.userIdCard, // 身份证号
              userMail: this.ruleForm.userMail, // 邮箱
              userRealname: this.ruleForm.userRealname // 用户姓名
            };
          }
          this.$request({
            url: 'rest/bsp/pubUser/mergeUser',
            data: obj
          }).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.tableinfo();
            this.dialogVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.clearValidate();
    },
    close() {
      this.empty();
      this.submitShow = false;
    },
    // 删除
    handleDelete(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request({
          url: 'rest/bsp/pubUser/deleteUser',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.tableinfo();
        });
      });
    },
    // 重置密码
    reset(row) {
      this.pwdResetVisible = true;
      this.userId = row.id;
    },
    resetPwdSubmit() {
      if (!this.newPwd) {
        this.errMsg = '请输入新密码';
        return;
      }
      if (!this.confirmPwd) {
        this.errMsg = '请输入确认密码';
        return;
      }
      if (this.newPwd !== this.confirmPwd) {
        this.errMsg = '两次密码不一致';
        return;
      }
      this.errMsg = '';
      this.$request({
        url: 'rest/bsp/pubUser/resetLoginPwd',
        data: {
          id: this.userId,
          loginPwd: this.$util.pwdMd5(this.newPwd)
        }
      }).then(res => {
        this.pwdResetVisible = false;
        this.$message({
          message: '重置密码成功！',
          type: 'success'
        });
      });
    },
    // 关键字搜索角色
    searchRole() {
      const result = this.allAoleIdsData.filter(item => {
        return item.roleName.indexOf(this.keyword.trim()) > -1;
      });
      this.roleIdsData = [...result];
    },
    // 全选 反选
    checkAllChange() {
      this.ruleForm.roleIds = [];
      if (this.allRroleChecked) {
        this.ruleForm.roleIds = this.allAoleIdsData.map(item => {
          return item.roleId;
        });
      }
    }
  }
};
</script>
<style>
.el-tree-node__content {
  font-size: 14px !important;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #d9d9d9;
}
.el-input.is-disabled .el-input__inner {
  background: none !important;
  border-color: #e4e7ed;
  color: #5a5e66;
  cursor: not-allowed;
}
</style>

<style lang="stylus" scoped>
@import './common.styl'
.line
  i
    cursor pointer
    font-style normal
    font-weight normal
  .style
    background #39be6b
    border-radius 3px
    padding 2px 3px
    font-size 10px
    color #fff
    text-align center
  .Edit
    background #298cf1
  .Delete
    background #ee3c0c
  .selectList
    height 100vh
    margin-right 10px
    border 1px solid #d9e4f4
    background #fff
  .content
    background #fff
    height 100vh
    padding 10px 10px 0 10px
  .custom-tree-node
    flex 1
    display flex
    align-items center
    justify-content space-between
    font-size 12px !important
    padding-right 8px
    .el-button--text
      margin-left 20px
    span
      font-size 12px !important
.changeBtn
  margin 10px 0 10px 0
  float right
  cursor pointe
.back
  width 100%
  height 100%
  background rgba(0, 0, 0, 0.4)
  position fixed
  top 0
  left 0
  z-index 10
  .submitForm
    position absolute
    top 130px
    left 33%
    width 660px
    height 480px
    overflow-y auto
    background #fff
    padding 15px
    .iconClose
      position absolute
      top 10px
      right 10px
      width 20px
      height 20px
      border-radius 100%
      border 1px solid
      text-align center
      line-height 20px
      cursor pointer
      z-index 9999
  .el-form-item__label,
  .el-input,
  .el-date-editor .el-range-input,
  .el-table thead,
  .el-table__row
    width 180px !important
    font-size 14px !important
.orgRegionCode_input
  -webkit-appearance none
  background-color #fff
  border-radius 0
  border 1px solid #d9d9d9
  box-sizing border-box
  color #5b5f67
  display inline-block
  height 30px
  line-height 30px
  outline 0
  width 100%
  cursor pointer
  margin-top 6px
  font-size 12px
  text-align center
  overflow hidden
  white-space nowrap
  text-overflow ellipsi
.backTree
  width 100%
  height 100%
  position fixed
  top 0
  left 0
  background rgba(0, 0, 0, 0.5)
  z-index 10000
  .tree
    position absolute
    top 25%
    left 40%
    width 500px
    height 400px
    background #fff
    padding 20px 0 0 20px
    overflow auto
    overflow-x hidden
  .sureBtn
    position absolute
    top 10px
    right 80px
    cursor pointer
  .closeBtn
    position absolute
    top 10px
    right 10px
    cursor pointer
.checkbox-container
  border 1px solid #ccc
  border-radius 8px
  padding 0 10px
  height 400px
  overflow auto
  margin-top 20px
.checkbox-operate
  position absolute
  right -60px
  bottom -10px
.err-tips
  color #f50
  padding-left 12px
.pagination
  padding 20px
  background #fff
  text-align right
</style>
